import * as Props from "./types";
import styles from "./styles.module.scss";

export const HeaderComponent: React.FC<Props.Base> = ({ children }) => (
  <header className={styles.header}>{children}</header>
);
